import { useEffect, useState } from 'react'
import { sidebarStateName, userDataName } from 'config/globalVariables'
import type { User } from 'types/User'

const getLocalStorageData = () => {
  // The initial state is derived from localStorage
  const localStorageExpandState = localStorage.getItem(sidebarStateName)
  const localStorageUserData = localStorage.getItem(userDataName)

  if (localStorageUserData === null) {
    return {
      isExpand: true,
      userData: {
        name: 'not found user name',
        email: 'not found user email',
      },
    }
  }

  const userData: Pick<User, 'name' | 'email'> = JSON.parse(localStorageUserData)

  return {
    isExpand: localStorageExpandState ? localStorageExpandState === 'true' : true,
    userData: {
      name: userData.name ?? '',
      email: userData.email ?? '',
    },
  }
}

type ReturnType = {
  isExpand: boolean
  userData: Pick<User, 'name' | 'email'>
  toogleSidebar: () => void
}

// This hook manages the state of the sidebar, including its expanded/collapsed state and user data
export const useSidebar = (): ReturnType => {
  const [sidebarState, setSidebarState] = useState(() => getLocalStorageData())

  useEffect(() => {
    setSidebarState(getLocalStorageData())
  }, [])

  const toogleSidebar = (): void => {
    setSidebarState(prev => {
      // The updated expanded state is saved to localStorage
      localStorage.setItem(sidebarStateName, (!prev.isExpand).toString())

      return {
        ...prev,
        isExpand: !prev.isExpand,
      }
    })
  }

  return { ...sidebarState, toogleSidebar }
}
